import { CustomTableConfig } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { getBasicColumnConfig } from 'core/utils/format-table-cell';
import { EditableColumn } from 'modules/global/model';
import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';

export const useDefaultConfigEapSettingsList = () => {
    const { t } = useTranslation();

    const getHeaderColumn = (column: string) => `settings.devices.eap-settings.eap-config-list.${column}`;

    const getColumnsToShow = (): EditableColumn[] => [
        {
            field: 'name',
            text: t('settings.devices.eap-settings.eap-config-list.name'),
            visible: true,
            pinned: false,
            columnIndex: 0,
        },
        {
            field: 'ssid',
            text: t('settings.devices.eap-settings.eap-config-list.ssid'),
            visible: true,
            pinned: false,
            columnIndex: 1,
        },
        {
            field: 'cipherType',
            text: t('settings.devices.eap-settings.eap-config-list.cipherType'),
            visible: true,
            pinned: false,
            columnIndex: 2,
        },
        {
            field: 'eapType',
            text: t('settings.devices.eap-settings.eap-config-list.eapType'),
            visible: true,
            pinned: false,
            columnIndex: 3,
        },
        {
            field: 'username',
            text: t('settings.devices.eap-settings.eap-config-list.username'),
            visible: true,
            pinned: false,
            columnIndex: 4,
        },
        {
            field: 'caCertificateFilename',
            text: t('settings.devices.eap-settings.eap-config-list.caCertificateFilename'),
            visible: true,
            pinned: false,
            columnIndex: 5,
        },
        {
            field: 'clientCertificateFilename',
            text: t('settings.devices.eap-settings.eap-config-list.clientCertificateFilename'),
            visible: true,
            pinned: false,
            columnIndex: 6,
        },
        {
            field: 'clientPrivateKeyFilename',
            text: t('settings.devices.eap-settings.eap-config-list.clientPrivateKeyFilename'),
            visible: true,
            pinned: false,
            columnIndex: 7,
        },
    ];

    const getDefaultConfig = (): CustomTableConfig<EapSettings> => ({
        entity: 'deviceConfiguration',
        columnsToShow: getColumnsToShow(),
        fields: [
            getBasicColumnConfig(t, getHeaderColumn, 'name', false),
            getBasicColumnConfig(t, getHeaderColumn, 'ssid', false),
            {
                name: 'cipherType',
                headerOptions: {
                    text: t(getHeaderColumn('cipherType')),
                    sortable: false,
                },
                rowOptions: {
                    cellOptions: {
                        format: (eapSetting: EapSettings) =>
                            eapSetting.cipherType === 'BOTH' ? 'AES-TKIP' : eapSetting.cipherType,
                    },
                },
            },
            getBasicColumnConfig(t, getHeaderColumn, 'eapType', false),
            getBasicColumnConfig(t, getHeaderColumn, 'username', false),
            getBasicColumnConfig(t, getHeaderColumn, 'caCertificateFilename', false),
            getBasicColumnConfig(t, getHeaderColumn, 'clientCertificateFilename', false),
            getBasicColumnConfig(t, getHeaderColumn, 'clientPrivateKeyFilename', false),
        ],
    });

    return { getDefaultConfig };
};
